export const SESSION_ID_PARAM = 'session';
export const SESSION_ID_REQUEST_PARAM = 'sessionRequest';
export const CONNECTION_METHOD_PARAM = 'method';
export const SEARCH_PARAM = 'search';
export const REFETCH_DELAY = 3000;
